import { formatPreciseNumber } from '@blockworks/platform/utils';
import { Bit } from '@blockworks/ui/bit';
import { formatUsd, formatUsdLong } from '@blockworks/ui/charts/utils';
import { FlexBox, Text } from '@blockworks/ui/components';
import { localeFormat } from '@blockworks/viz';

export const ThresholdChangeTooltip = (props: any) => {
    const aboveThreshold = Number(props.datum[props.dataKey]) > 0;
    const symbol = aboveThreshold ? '+' : '';
    return (
        <Bit.div p={2}>
            <FlexBox col gap="xs">
                <FlexBox col>
                    <Text size="xs" weight="bold" color="muted">
                        {localeFormat.local.full(props.datum[props.dateKey])}
                    </Text>
                </FlexBox>
                {['open', 'close'].map(key => (
                    <FlexBox justifyContent="between" gap="md" key={`datum-${key}`}>
                        <Text size="xs" weight="regular" capitalize color="deselect">
                            {key}
                        </Text>
                        <Text size="xs" weight="regular" color="highlight">
                            {formatUsd(props.datum[key])}
                        </Text>
                    </FlexBox>
                ))}
                <Text size="xs" weight="regular" color={aboveThreshold ? 'success' : 'danger'}>
                    {symbol}
                    {formatUsd(props.datum.close - props.datum.open)} ({symbol}
                    {props.formatY(props.datum[props.dataKey])})
                </Text>
            </FlexBox>
        </Bit.div>
    );
};

export const ThresholdUsdTooltip = (props: any) => (
    <Bit.div p={1}>
        <Text size="xs" weight="medium" color="deselect" mb={1}>
            {localeFormat.local.full(props.datum[props.dateKey])}
        </Text>
        <FlexBox gap="md" center>
            <Text size="sm" weight="semibold" color="muted">
                {formatUsdLong(props.datum[props.dataKey])}
            </Text>
        </FlexBox>
    </Bit.div>
);

export const ThresholdBtcTooltip = (props: any) => (
    <Bit.div p={1}>
        <Text size="xs" weight="medium" color="deselect" mb={1}>
            {localeFormat.local.full(props.datum[props.dateKey])}
        </Text>
        <FlexBox gap="md" center>
            <Text size="sm" weight="semibold" color="muted">
                {formatPreciseNumber(props.datum[props.dataKey])} BTC
            </Text>
        </FlexBox>
    </Bit.div>
);
